import {useEffect, useMemo, useState} from "react";
import {isValidEmail} from "utils";
import Button from "../../ui/Button";
import Input from "../../ui/Input";
import Field from "../../ui/Field";
import {FormattedMessage, useIntl} from "react-intl";

export default function StepEmail(props: {
    email: string
    onContinue: (email: string) => void
}) {
    const intl = useIntl()
    const [emailVal, setEmailVal] = useState('')
    useEffect(() => {
        if (props.email) {
            setEmailVal(props.email)
        }
    }, []);

    const canContinue = useMemo(() => {
        return isValidEmail(emailVal)
    }, [emailVal])

    const onContinue = async () => {
        props.onContinue(emailVal)
    }

    return <div className="matchid-email-email-box">
        <Field label={intl.formatMessage({
            id:"emailAddress"
        })}>
            <Input
                placeholder={intl.formatMessage({
                    id:"emailAddressPlaceholder"
                })}
                onChange={e => setEmailVal(e.target.value)}
                value={emailVal}
            />
        </Field>

        <Button disabled={!canContinue} style={{
            marginTop:"64px"
        }} onClick={onContinue} size={"lg"} block highlight><FormattedMessage id={"continue"}/></Button>

    </div>
}
